export * from './avatar-component-config.interface';
export * from './avatar-shape.enum';
export * from './avatar-size.enum';
